import React from "react";
import { connect } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import VitalForm from "./VitalForm";
import { patientDetail } from "store/slice/patient-detail-slice";
import utils from "utils";
import "./VitalForm.scss";
function VitalFormCareAdmin(props) {
  const location = useLocation();
  const history = useHistory();
  const patientDetails = location?.patientDetails || props.patient_id;
  props.patientDetail(patientDetails); 
  return (
    <div className="vitalFormCareAdmin">
      {/* <div style={{display:"flex"}}> */}
      <div
        onClick={() => {
          history.push(`${props.user_details.baseUrl}/search-patient`);
        }}
        className="previous-page-button"
      >{`< Back To Previous Page`}</div>
      {
        // props.user_details?.role == "patient" &&
        patientDetails?.patient_name || props.patientDetails.patient_name ? (
          <div className="patientUid">
            <label className="patient-name-uid">
              {utils.FirstNameLastName(
                utils.FormatName(
                  `${patientDetails?.patient_name} ${patientDetails?.patient_last_name}` ||
                    utils.getDisplayName(
                      props.patientDetails.patient_name,
                      props.patientDetails.patient_last_name
                    )
                ),
                "700px"
              )}
            </label>
            <div className="patient-plan-uid-num ">
              {patientDetails?.patient_uid || props.patientDetails.patient_uid}
            </div>
          </div>
        ) : (
          ""
        )
      }
      {/* </div> */}
      <VitalForm patientDetails={patientDetails} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer?.user_details,
    patient_id: state.patientDetailReducer.patient_detail,
  };
};
const mapDispatchToProps = {
  patientDetail,
};
export default connect(mapStateToProps, mapDispatchToProps)(VitalFormCareAdmin);
